import { IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';

export function GoBackIconButton({ form }: any) {
  const navigate = useNavigate();

  return (
    <IconButton
      sx={{ width: 'fit-content', justifyContent: 'flex-start' }}
      onClick={() => {
        navigate(`/category`);
        form.reset();
      }}
    >
      <KeyboardArrowLeftIcon />
    </IconButton>
  );
}
